import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordOrPinCodeGuard implements CanActivate {
  constructor(private loginInfo: LoginInfoService, private router: Router) { }
  canActivate() {
    if (this.loginInfo.tokenHash) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }
}
